// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Skeleton placeholder for the items table while data is loading.
 */
export function ItemsTableSkeleton() {
  const rows = Array.from({ length: 5 }, (_, i) => i);

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="medium" sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 120 }}>Type</TableCell>
            <TableCell sx={{ minWidth: 200 }}>Name</TableCell>
            <TableCell sx={{ width: 150 }}>SKU</TableCell>
            <TableCell sx={{ minWidth: 200 }}>Description</TableCell>
            <TableCell sx={{ width: 150 }}>Last updated</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row}>
              <TableCell>
                <Skeleton variant="rounded" width={80} height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="80%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={100} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="60%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={80} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
